import '../../App.css';
import WalletCard from  '../WalletCard/WalletCard.jsx';
import StepsCards from '../StepsCards/StepsCards.jsx';
import Transactions from '../Transactions/Transactions.jsx';
import MattiasAgeTracker from '../MattiasAgeTracker /MattiasAgeTracker .jsx';
import CryptoKPI from '../CryptoKPI.jsx';
import DividenKPI from '../DividenKPI.jsx';
import { Heading, Box } from '@chakra-ui/react';
import Page from '../UI/Page.jsx';

const Home = () => {
  return (
    <Page className="app">
      <div className="hero">
        <div className="hero-content">
          <StepsCards />
        </div>

        <div className="hero-content">
          <MattiasAgeTracker/>
        </div>


        <div className="hero-content">
          <DividenKPI/>
        </div>

        
            <Box textAlign="center" mb={2} mt={4}>
              <Heading fontSize="xl !important" color="teal.300">
                📊 Portfolio Crypto
              </Heading>
              <Box 
                h="2px" 
                w="50px" 
                bg="teal.300" 
                mx="auto" 
                mt={2} 
                borderRadius="full"
              />
            </Box>
              <div className="hero-content">
                <CryptoKPI/>
              </div>
        <main className="wallet-section">
          <div className="wallets">
            <WalletCard
              name="Litecoin"
              address="ltc1qt6tjlz3x0rhdsyvc96rvesk5ynlumn29ulgnr6"
              qrCode="ltc"
              code="LTC"
              logo="ltclogo"
              explorer="litecoin"
              symbol="ltc"
            />

            <WalletCard
              name="Doge"
              address="DLjbE1thbghL9MJbfEve3roAvBVQcejPRt"
              qrCode="doge"
              code="DOGE"
              logo="dogelogo"
              explorer="dogecoin"
              symbol="doge"
            />

            <WalletCard
              name="Bitcoin Cash"
              address="qpngrxn4a3nv8rzvceu8x3k2kczcv6hpcspxkrp6qf"
              qrCode="bch"
              code="BCH"
              logo="bchlogo"
              explorer="bitcoin-cash"
              symbol="bch"
            />

            <WalletCard
              name="Dash"
              address="XmYVV1G5A1owwzCFkYBwjDrmGnpGbHWANQ"
              qrCode="dash"
              code="DASH"
              logo="dashlogo"
              explorer="dash"
              symbol="dash"
            />

            <WalletCard
              name="Polygon"
              address="0x37FECd8E8D9DC576851903c5a99709f3e0A42357"
              qrCode="pol"
              code="POL"
              logo="pollogo"
              explorer="pol"
              symbol="pol"
            />

                        <WalletCard
              name="Zcash"
              address="t1XzbCqLjjZb6H9NRYg8XTDAAVsWajcBG2Z"
              qrCode="zec"
              code="ZEC"
              logo="zeclogo"
              explorer="zcash"
              symbol="zec"
            />
          </div>
        </main>

        <div className="hero-content">
          <Transactions/>
        </div>
      </div>
    </Page>
  )
}

export default Home